import SelectCardApi from "@/api/cardBind";
import { Component, Vue } from "vue-property-decorator";

interface UserInfo {
  idCardNo: string;
  phone: string;
  userName: string;
}

const style = require("./index.module.scss");

@Component({ name: "YhPreApplyContracts" })
export default class YhPreApplyContracts extends Vue {
  private contractUserInfo: UserInfo = {
    idCardNo: "",
    phone: "",
    userName: "",
  };

  private async created() {
    this.contractUserInfo = await SelectCardApi.getUserInfomation();
  }

  private render() {
    return (
      <div class={style.YhPreApplyContracts}>
        <div class={style.content}>
          <p class={[style.title, style.blod]}>
            <span>
              <strong>征信授权书</strong>
            </span>
          </p>
          <p class={style.title}>
            <span>(</span>
            <span>适用于个人客户本人申请个人贷款</span>
            <span>)</span>
          </p>
          <br />
          <p>
            <span>湖南三湘银行股份有限公司（以下简称</span>
            <span>&ldquo;</span>
            <span>贵行</span>
            <span>&rdquo;</span>
            <span>）：</span>
          </p>
          <p class={style.textTip}>
            <span>
              本人在此不可撤销地授权并同意贵行有权在为本人或／及本人所在单位提供金融产品或服务过程中，按照《征信业管理条例》等相关法律法规的规定查询、使用、报送本人的全部或部分信息，具体约定如下：
            </span>
          </p>

          <p class={style.textTip}>
            <span>
              一、本人授权贵行通过中国人民银行征信中心金融信用信息基础数据库、其他依法设立的征信机构（包括但不限于百行征信有限公司等经国务院或其他政府有权部门批准合法设立的其他征信机构）收集、查询、了解、分析和使用本人信息。
            </span>
          </p>

          <p class={style.textTip}>
            <span>
              二、本人同意并授权贵行在办理涉及本人个人贷款业务时；在授信前调查、审查审批、合同签署、放款支用、贷后检查、贷款清收等环节，可以向前述数据库和信息库查询本人的信息，并有权对查询到的本人信息进行打印、保存和使用。
            </span>
          </p>

          <p class={style.textTip}>
            <span>
              三、贵行有权将了解到的本人信息，包括信贷信息在内的相关信用信息以及包含本人因未及时履行合同义务产生的不良信息（包括《征信业管理条例》规定有关不良信息）录入中国人民银行征信中心金融信用信息基础数据库或其他依法设立的征信机构等。
            </span>
          </p>

          <p class={style.textTip}>
            <span>
              四、贵行应承诺将要求接收贵行披露资料的机构对本人的信息承担保密义务。
            </span>
          </p>

          <p class={style.textTip}>
            <strong>
              五、若第二条所述的涉及本人的业务审批不通过、未实际发生，本人同意贵行保留本授权书以及本人的基础资料、信用报告、信贷业务申请书等。
            </strong>
          </p>
          <p class={style.textTip}>
            <strong>
              六、本授权书自出具之日起生效，在本人接受贵行提供金融产品、金融服务以及与贵行开展其他业务期间持续有效，非经贵行书面同意本授权书不可撤销。
            </strong>
          </p>
          <p class={style.textTip}>
            <strong>
              本人声明：贵行已经依法向本人提示了相关条款，已应本人的要求对上述条款作出相应的说明。本人已经完全知悉并充分理解本授权书条款的内容及相应的法律后果，并愿意接受本授权书条款的约定。
            </strong>
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p class={style.bottom}>
            <span>授权人（签字）：&nbsp;{this.contractUserInfo.userName}</span>
          </p>
          <p class={style.bottom}>
            <span>身份证件类型：&nbsp; 身份证</span>
          </p>
          <p class={style.bottom}>
            <span>身份证件号码：&nbsp;{this.contractUserInfo.idCardNo}</span>
          </p>
          <p class={style.bottom}>
            <span>出具日期：&nbsp;{new Date().toLocaleDateString()}</span>
          </p>
        </div>
      </div>
    );
  }
}
